'use client'

import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { DURATION_NORMAL, EASE_OUT, useReducedMotion, reduceMotion } from '@/lib/motion'

export interface ToggleButtonProps {
  expanded: boolean
  onClick: () => void
}

export function ToggleButton({ expanded, onClick }: ToggleButtonProps) {
  const prefersReduced = useReducedMotion()

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'absolute top-1/2 -translate-y-1/2',
        expanded ? '-right-7' : '-right-5',
        'flex items-center justify-center',
        'size-10',
        'bg-bg-primary border border-border-primary rounded-full',
        'shadow-sm',
        'hover:bg-bg-hover-subtle transition-colors',
        'z-10'
      )}
      title={expanded ? 'Collapse sidebar' : 'Expand sidebar'}
    >
      <motion.i
        animate={{ rotate: expanded ? 0 : 180 }}
        transition={reduceMotion(prefersReduced, { duration: DURATION_NORMAL, ease: EASE_OUT })}
        className="pi pi-chevron-left text-xs text-text-tertiary"
        aria-hidden="true"
      />
    </button>
  )
}
